__turbopack_context__.v({
  "dot": "InfiniteScrollLoadMore-module-scss-module__m3FyRa__dot",
  "dots": "InfiniteScrollLoadMore-module-scss-module__m3FyRa__dots",
});
